"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var Typography = function Typography(_ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "inherit" : _ref$size,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? "inherit" : _ref$weight,
      underline = _ref.underline,
      italic = _ref.italic,
      strike = _ref.strike,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "span" : _ref$variant,
      color = _ref.color,
      _ref$font = _ref.font,
      font = _ref$font === void 0 ? "primary" : _ref$font,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      breakPoint = _ref.breakPoint,
      _ref$autoResize = _ref.autoResize,
      autoResize = _ref$autoResize === void 0 ? true : _ref$autoResize;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var getThemeColor = function getThemeColor() {
    var functionalName = ["h1", "h2", "h3", "h4", "h5"].indexOf(variant) !== -1 ? "header" : "text";
    return functionalName === "header" ? theme.colors[type].header : theme.colors[type].text;
  };

  !color && (color = getThemeColor());
  var mobileBreakPoint = breakPoint && "".concat(breakPoint, "px") || theme.breakpoints.lg;
  var fontSize = "";
  var fontLineHeight = "";
  var mobileFontSize = "";
  var mobileLineHeight = "";
  var fontWeight = "";
  var fontFamily = "";

  switch (size) {
    case "xl":
      fontSize = theme.typography.fonts.sizes.xl.size;
      fontLineHeight = theme.typography.fonts.sizes.xl.lineHeight;
      mobileFontSize = theme.typography.fonts.sizes.lg.size;
      mobileLineHeight = theme.typography.fonts.sizes.lg.lineHeight;
      break;

    case "lg":
      fontSize = theme.typography.fonts.sizes.lg.size;
      fontLineHeight = theme.typography.fonts.sizes.lg.lineHeight;
      mobileFontSize = theme.typography.fonts.sizes.md.size;
      mobileLineHeight = theme.typography.fonts.sizes.md.lineHeight;
      break;

    case "md":
      fontSize = theme.typography.fonts.sizes.md.size;
      fontLineHeight = theme.typography.fonts.sizes.md.lineHeight;
      mobileFontSize = theme.typography.fonts.sizes.sm.size;
      mobileLineHeight = theme.typography.fonts.sizes.sm.lineHeight;
      break;

    case "sm":
      fontSize = theme.typography.fonts.sizes.sm.size;
      fontLineHeight = theme.typography.fonts.sizes.sm.lineHeight;
      mobileFontSize = theme.typography.fonts.sizes.xs.size;
      mobileLineHeight = theme.typography.fonts.sizes.xs.lineHeight;
      break;

    case "xs":
      fontSize = theme.typography.fonts.sizes.xs.size;
      fontLineHeight = theme.typography.fonts.sizes.xs.lineHeight;
      mobileFontSize = fontSize;
      mobileLineHeight = fontLineHeight;
      break;

    default:
      fontSize = "inherit";
      fontLineHeight = "inherit";
      mobileFontSize = "inherit";
      mobileLineHeight = "inherit";
  }

  switch (weight) {
    case "normal":
      fontWeight = theme.typography.fonts.weights.normal;
      break;

    case "bold":
      fontWeight = theme.typography.fonts.weights.bold;
      break;

    case "bolder":
      fontWeight = theme.typography.fonts.weights.bolder;
      break;

    default:
      fontWeight = "inherit";
  }

  switch (font) {
    case "primary":
      fontFamily = theme.typography.fontFamilies.primary;
      break;

    default:
      fontFamily = "inherit";
  }

  var Typography = null;

  switch (variant) {
    case "h1":
      Typography = styled_1.default.h1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\t", "\n\t\t\t"])), theme.typography.fontFamilies.headings, theme.typography.h1.fontSize, theme.typography.h1.fontWeight, theme.typography.h1.lineHeight, color, autoResize && "@media only screen and (max-width: ".concat(mobileBreakPoint, ") {\n\t\t\t\t\tfont-size: ").concat(theme.typography.h2.fontSize, ";\n\t\t\t\t\tline-height: ").concat(theme.typography.h2.lineHeight, ";\n\t\t\t\t\tfont-weight: ").concat(theme.typography.h2.fontWeight, ";\n\t\t\t\t}"));
      break;

    case "h2":
      Typography = styled_1.default.h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\t", "\n\t\t\t"])), theme.typography.fontFamilies.headings, theme.typography.h2.fontSize, theme.typography.h2.fontWeight, theme.typography.h2.lineHeight, color, autoResize && "@media only screen and (max-width: ".concat(mobileBreakPoint, ") {\n\t\t\t\t\tfont-size: ").concat(theme.typography.h3.fontSize, ";\n\t\t\t\t\tline-height: ").concat(theme.typography.h3.lineHeight, ";\n\t\t\t\t\tfont-weight: ").concat(theme.typography.h3.fontWeight, ";\n\t\t\t\t}"));
      break;

    case "h3":
      Typography = styled_1.default.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\t", "\n\t\t\t"])), theme.typography.fontFamilies.headings, theme.typography.h3.fontSize, theme.typography.h3.fontWeight, theme.typography.h3.lineHeight, color, autoResize && "@media only screen and (max-width: ".concat(mobileBreakPoint, ") {\n\t\t\t\t\tfont-size: ").concat(theme.typography.h4.fontSize, ";\n\t\t\t\t\tline-height: ").concat(theme.typography.h4.lineHeight, ";\n\t\t\t\t\tfont-weight: ").concat(theme.typography.h4.fontWeight, ";\n\t\t\t\t}"));
      break;

    case "h4":
      Typography = styled_1.default.h4(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\t", "\n\t\t\t"])), theme.typography.fontFamilies.headings, theme.typography.h4.fontSize, theme.typography.h4.fontWeight, theme.typography.h4.lineHeight, color, autoResize && "@media only screen and (max-width: ".concat(mobileBreakPoint, ") {\n\t\t\t\t\tfont-size: ").concat(theme.typography.h5.fontSize, ";\n\t\t\t\t\tline-height: ").concat(theme.typography.h5.lineHeight, ";\n\t\t\t\t\tfont-weight: ").concat(theme.typography.h5.fontWeight, ";\n\t\t\t\t}"));
      break;

    case "h5":
      Typography = styled_1.default.h5(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t"])), theme.typography.fontFamilies.headings, theme.typography.h5.fontSize, theme.typography.h5.fontWeight, theme.typography.h5.lineHeight, color);
      break;

    case "p":
      Typography = styled_1.default.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\t", ";\n\t\t\t"])), fontFamily, fontSize, fontWeight, fontLineHeight, color, autoResize && "@media only screen and (max-width: ".concat(mobileBreakPoint, ") {\n\t\t\t\t\tfont-size: ").concat(mobileFontSize, ";\n\t\t\t\t\tline-height: ").concat(mobileLineHeight, ";\n\t\t\t\t}"));
      break;

    case "div":
      Typography = styled_1.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\t", ";\n\t\t\t"])), fontFamily, fontSize, fontWeight, fontLineHeight, color, autoResize && "@media only screen and (max-width: ".concat(mobileBreakPoint, ") {\n\t\t\t\t\tfont-size: ").concat(mobileFontSize, ";\n\t\t\t\t\tline-height: ").concat(mobileLineHeight, ";\n\t\t\t\t}"));
      break;

    default:
      Typography = styled_1.default.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\t", ";\n\t\t\t"])), fontFamily, fontSize, fontWeight, fontLineHeight, color, autoResize && "@media only screen and (max-width: ".concat(mobileBreakPoint, ") {\n\t\t\t\t\tfont-size: ").concat(mobileFontSize, ";\n\t\t\t\t\tline-height: ").concat(mobileLineHeight, ";\n\t\t\t\t}"));
  }

  if (underline) {
    Typography = (0, styled_1.default)(Typography)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\ttext-decoration: underline;\n\t\t"])));
  }

  if (italic) {
    Typography = (0, styled_1.default)(Typography)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\tfont-style: italic;\n\t\t"])));
  }

  if (strike) {
    Typography = (0, styled_1.default)(Typography)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\ttext-decoration: line-through;\n\t\t"])));
  }

  return (0, jsx_runtime_1.jsx)(Typography, {
    className: className,
    "data-testid": dataTestId,
    children: children
  });
};

exports.Typography = Typography;